/**
 * Created by razial on 13.03.2026.
 */

const EditorMap2dReferenceControls = cc.Node.extend({
    ctor: function (reference) {
        this._super();

        this.reference = reference;

        const styles = cleverapps.styles.EditorMap2dReferenceControls;

        const keyToLetter = {};
        for (const keyName in InputDispatcher.KEY) {
            keyToLetter[InputDispatcher.KEY[keyName]] = keyName;
        }

        this.editHint = new EditorHintView();
        this.editHint.refresh(EditorMap2dReferenceControls.COMMANDS.map((command) => ({
            key: `${command.key !== undefined ? `${keyToLetter[command.key]} + ` : ""}⬅⬆`,
            description: command.description
        })));
        this.editHint.setAnchorPoint(0, 0.5);
        this.editHint.setAlignment(styles.editHint);
        this.addChild(this.editHint);

        this.createScaleHint();
        this.reference.on("imageScaleChanged", () => this.createScaleHint());

        const panel = new cleverapps.Layout([
            this.createEditToggle(),
            this.createVisibilityToggle(),
            this.createOpacityControl()
        ], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        panel.setAnchorPoint(0.5, 0.5);
        panel.setPosition(panel.width / 2, panel.height / 2);
        this.addChild(panel);

        this.setContentSize(panel.width, panel.height);

        this.setAlignment(styles.position);
    },

    createRow: function (label, control) {
        const styles = cleverapps.styles.EditorMap2dReferenceControls;

        const text = cleverapps.UI.generateOnlyText(label, cleverapps.styles.FONTS.EDITOR_BLUE_TEXT);
        text.setDimensions(styles.labelColumnWidth, styles.button.height);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_RIGHT);
        text.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);

        const controlContainer = new cc.Node();
        controlContainer.setContentSize(styles.controlColumnWidth, control.height);
        controlContainer.setAnchorPoint(0, 0.5);
        controlContainer.addChild(control);
        control.setPosition(control.width / 2, controlContainer.height / 2);

        return new cleverapps.Layout([text, controlContainer], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    createVisibilityToggle: function () {
        const checkBox = new cleverapps.UI.CheckBox({
            onChange: function (state) {
                this.reference.setImageVisible(state);
            }.bind(this)
        });

        this.reference.on("imageVisibilityChanged", () => {
            checkBox.setSelected(this.reference.isImageVisible());
        });

        return this.createRow("show ref", checkBox);
    },

    createOpacityControl: function () {
        const styles = cleverapps.styles.EditorMap2dReferenceControls;

        const opacityLabel = cleverapps.UI.generateOnlyText(
            this.reference.getImageOpacity(),
            cleverapps.styles.FONTS.EDITOR_BLUE_TEXT
        );
        opacityLabel.setDimensions(styles.valueWidth, 0);
        opacityLabel.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        this.reference.on("imageOpacityChanged", () => {
            opacityLabel.setString(this.reference.getImageOpacity());
        });

        const decreaseButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.editor,
            content: new cc.Sprite(bundles.admin.frames.left),
            width: styles.button.width,
            height: styles.button.height,
            onClicked: this.changeOpacity.bind(this, -EditorMap2dReferenceControls.OPACITY_STEP)
        });

        const increaseButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.editor,
            content: new cc.Sprite(bundles.admin.frames.right),
            width: styles.button.width,
            height: styles.button.height,
            onClicked: this.changeOpacity.bind(this, EditorMap2dReferenceControls.OPACITY_STEP)
        });

        const controls = new cleverapps.Layout([decreaseButton, opacityLabel, increaseButton], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        return this.createRow("opacity", controls);
    },

    createEditToggle: function () {
        const checkBox = new cleverapps.UI.CheckBox({
            onChange: function (state) {
                this.reference.setImageEditable(state);
            }.bind(this)
        });

        const onImageEditableChange = () => {
            checkBox.setSelected(this.reference.isImageEditable());

            if (this.reference.isImageEditable()) {
                this.startEditing();
            } else {
                this.stopEditing();
            }
        };

        this.reference.on("imageEditableChanged", () => onImageEditableChange());

        onImageEditableChange();

        return this.createRow("edit ref", checkBox);
    },

    createScaleHint: function () {
        if (this.scaleHint) {
            this.scaleHint.removeFromParent();
            this.scaleHint = undefined;
        }

        const styles = cleverapps.styles.EditorMap2dReferenceControls.scaleHint;

        const text = cleverapps.UI.generateOnlyText(`scale: ${this.reference.getImageScale()}`, cleverapps.styles.FONTS.EDITOR_HINT);

        const layout = new cleverapps.Layout([text], {
            direction: cleverapps.UI.VERTICAL,
            padding: styles.padding
        });
        layout.setAnchorPoint(0.5, 0.5);
        layout.setPosition(layout.width / 2, layout.height / 2);

        const background = this.scaleHint = new cc.Scale9Sprite(bundles.tool.frames.tool_bg);
        background.setContentSize(layout.width, layout.height);
        background.setAnchorPoint(0, 0.5);
        background.setAlignment(styles);
        background.addChild(layout);
        background.setVisible(this.reference.isImageEditable());
        this.addChild(background);
    },

    startEditing: function () {
        this.editHint.setVisible(true);
        this.scaleHint.setVisible(true);

        this.keyboardListener = cleverapps.inputDispatcher.on("keypressed", (key) => {
            const arrowKeys = [InputDispatcher.KEY.up, InputDispatcher.KEY.down, InputDispatcher.KEY.left, InputDispatcher.KEY.right];
            if (!arrowKeys.includes(key) || Editor.currentEditor.boundsMode) {
                return;
            }

            const command = EditorMap2dReferenceControls.COMMANDS.find((cmd) => !cmd.key || cleverapps.inputDispatcher.isPressed(cmd.key));
            if (command) {
                command.action(this.reference, key);
            }
        }, this);
    },

    stopEditing: function () {
        this.editHint.setVisible(false);
        this.scaleHint.setVisible(false);

        if (this.keyboardListener) {
            this.keyboardListener.clear();
            delete this.keyboardListener;
        }
    },

    changeOpacity: function (delta) {
        const opacity = cc.clampf(this.reference.getImageOpacity() + delta, 0, 255);
        this.reference.setImageOpacity(opacity);
    }
});

EditorMap2dReferenceControls.OPACITY_STEP = 25;

EditorMap2dReferenceControls.COMMANDS = [{
    description: "Rotate",
    key: InputDispatcher.KEY.r,
    action: function (reference, arrowKey) {
        const rotation = reference.getImageRotation();

        switch (arrowKey) {
            case InputDispatcher.KEY.up:
            case InputDispatcher.KEY.right: reference.setImageRotation(rotation + 1); break;
            case InputDispatcher.KEY.down:
            case InputDispatcher.KEY.left: reference.setImageRotation(rotation - 1); break;
        }
    }
}, {
    description: "Skew",
    key: InputDispatcher.KEY.k,
    action: function (reference, arrowKey) {
        const skew = reference.getImageSkew();

        switch (arrowKey) {
            case InputDispatcher.KEY.left: reference.setImageSkew(skew.x - 1, skew.y); break;
            case InputDispatcher.KEY.right: reference.setImageSkew(skew.x + 1, skew.y); break;
            case InputDispatcher.KEY.down: reference.setImageSkew(skew.x, skew.y - 1); break;
            case InputDispatcher.KEY.up: reference.setImageSkew(skew.x, skew.y + 1); break;
        }
    }
}, {
    description: "Scale",
    key: InputDispatcher.KEY.s,
    action: function (reference, arrowKey) {
        const scale = reference.getImageScale();
        const step = 0.05;

        switch (arrowKey) {
            case InputDispatcher.KEY.up:
            case InputDispatcher.KEY.right: reference.setImageScale(+(scale + step).toFixed(2)); break;
            case InputDispatcher.KEY.down:
            case InputDispatcher.KEY.left: reference.setImageScale(+(scale - step).toFixed(2)); break;
        }
    }
}, {
    description: "Move",
    key: undefined,
    action: function (reference, arrowKey) {
        const step = cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.shift) ? 20 : 1;
        const position = reference.getImagePosition();

        switch (arrowKey) {
            case InputDispatcher.KEY.left: reference.setImagePosition(position.x - step, position.y); break;
            case InputDispatcher.KEY.right: reference.setImagePosition(position.x + step, position.y); break;
            case InputDispatcher.KEY.down: reference.setImagePosition(position.x, position.y - step); break;
            case InputDispatcher.KEY.up: reference.setImagePosition(position.x, position.y + step); break;
        }
    }
}];

cleverapps.styles.EditorMap2dReferenceControls = {
    position: {
        x: { align: "left", dx: 300 },
        y: { align: "top", dy: -20 }
    },

    margin: 10,

    button: {
        width: 60,
        height: 60
    },

    labelColumnWidth: 150,
    controlColumnWidth: 200,
    valueWidth: 50,

    editHint: {
        x: { align: "right", anchor: false, dx: 20 },
        y: { align: "center", dy: 20 }
    },

    scaleHint: {
        x: { align: "right", anchor: false, dx: 20 },
        y: { align: "center", dy: -80 },

        padding: {
            x: 10,
            y: 10
        }
    }
};
